import { render } from "./ListeCollection.vue?vue&type=template&id=d2967a70&ts=true"
import script from "./ListeCollection.vue?vue&type=script&lang=ts"
export * from "./ListeCollection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__